import c3 from 'c3';

Hop.defineModule('freelance-growth', (domRoot) => {
    const FREELANCER_GROWTH_DATA = window.freelancerGrowthData;
    const TOOLTIP_TPL = $('#tooltipTemplate').html();
    const graphContainerSelector = '#freelancerGrowth';
    const GRAPH_OPTIONS = {
        bindto: graphContainerSelector,
        data: {
            x: 'date',
            columns: [
                ['date'].concat(
                    FREELANCER_GROWTH_DATA.reduce((prev, curr) => {
                        return [...prev, curr.key];
                    }, []),
                ),
                ['data'].concat(
                    FREELANCER_GROWTH_DATA.reduce((prev, curr) => {
                        return [...prev, curr.value];
                    }, []),
                ),
            ],
            type: 'spline',
        },
        axis: {
            x: {
                tick: {
                    outer: false,
                },
                padding: {
                    left: 0.3,
                    right: 0.3,
                },
            },
            y: {
                tick: {
                    outer: false,
                },
            },
        },
        grid: {
            y: {
                show: true,
            },
        },
        color: {
            pattern: ['#4dd0e1'],
        },
        legend: {
            show: false,
        },
        tooltip: {
            contents: (data) => {
                const key = data[0].x;
                const value = data[0].value;
                return Hop.template(TOOLTIP_TPL, {variable: 'm'})({key, value});
            },
        },
        point: {
            r: 3.5,
            focus: {
                expand: {
                    r: 8,
                },
            },
        },
    };

    // eslint-disable-next-line prefer-const
    let chart;

    function freelanceGrowthChart() {
        return c3.generate(GRAPH_OPTIONS);
    }

    function ensureChartFitToHisParent() {
        const $graphContainer = $(graphContainerSelector);
        $graphContainer.css({
            maxWidth: `${$graphContainer.parent().width()}px`,
            maxHeight: `${$graphContainer.parent().height()}px`,
        });
        $(window).trigger('resize'); // trigger to ensure graph is not outside of his parent
    }

    function showTooltipForLastYear() {
        chart.tooltip.show({x: FREELANCER_GROWTH_DATA[FREELANCER_GROWTH_DATA.length - 1].key});
        const $tooltip = $(domRoot).find('.c3-tooltip-container');
        $tooltip.css({top: `${$tooltip.position().top + 40}px`});
    }

    function setUpHandlers() {
        $(graphContainerSelector).on('mouseout', showTooltipForLastYear);
    }

    chart = freelanceGrowthChart();
    ensureChartFitToHisParent();
    showTooltipForLastYear();
    setUpHandlers();
});
